import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CatalogPage from './pages/CatalogPage';
import Layout from './components/Layout';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProductMatrixProvider } from './contexts/ProductMatrixContext';
function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="shift4-theme">
      <ProductMatrixProvider>
        <Router>
          <Layout>
            <Routes>
              {/* All routes handled by CatalogPage component */}
              <Route path="/" element={<CatalogPage />} />
              <Route path="/location" element={<CatalogPage />} />
              <Route path="/location/:region" element={<CatalogPage />} />
              <Route path="/location/:region/:country" element={<CatalogPage />} />
              <Route path="/browse" element={<CatalogPage />} />
              <Route path="/platform/:platformName" element={<CatalogPage />} />
              <Route path="/onboarding" element={<CatalogPage />} />
              <Route path="/onboarding/:countryCode" element={<CatalogPage />} />
            </Routes>
          </Layout>
        </Router>
      </ProductMatrixProvider>
    </ThemeProvider>
  );
}

export default App;
